/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_TitleInputs */

const en_dr_steps_title = /** @type {(inputs: Dr_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six steps, each with a rule`)
};

const id_dr_steps_title = /** @type {(inputs: Dr_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah, tiap langkah punya aturan`)
};

/**
* | output |
* | --- |
* | "Six steps, each with a rule" |
*
* @param {Dr_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_title = /** @type {((inputs?: Dr_Steps_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_title(inputs)
	return en_dr_steps_title(inputs)
});